import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import { PersonInfoModel } from "../../models/person/personInfoModel";

/** Модель ссмены пароля */
export class SbpBankSelectModel extends OperationModel {
  /**Список банков к аццептированию */
  public banksList: Array<any> = [];
  /**Признак разрешенных входящих переводов сбп */
  public sbpIn: boolean = false;

  constructor() {
    super();
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;
    const AcceptedBanks: Array<any> = this.banksList.filter((item: any) => item.value);
    const resString: string = AcceptedBanks.reduce((cur, prev) => cur + prev.id + ',', '');
    const accBanks = resString.substring(0, resString.length-1);
    ord.setProperty("AcceptedBanks", `${accBanks.length > 0 ? accBanks : "emptyList"}|${this.sbpIn ? "1" : "0"}` , DeclarationPropertiesTypes.String);

    return ord;
  }

  public createBanksRequest(code: string): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = code;
    ord.operationId = this.OperationId;

    ord.setProperty("filter", "Me2MePull:R", DeclarationPropertiesTypes.String);

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }
}
